export enum Constants {
  DISPENSERS_ADD_NEW_DISPENSER = 'DISPENSERS_ADD_NEW_DISPENSER',
  DISPENSERS_SET_LOADING = 'DISPENSERS_SET_LOADING',
  DISPENSERS_SET_DISPENSERS = 'DISPENSERS_SET_DISPENSERS',
  DISPENSERS_SET_MAPPING_LOADER = 'DISPENSERS_SET_MAPPING_LOADER',
  DISPENSERS_SET_CURRENT_DISPENSER_DATA = 'DISPENSERS_SET_CURRENT_DISPENSER_DATA'

}